import React from 'react'
import { MinusOutlined, DownloadOutlined, PlusOutlined, ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import Chart from 'chart.js/auto';
import { Collapse, Select } from 'antd';
import { Bar } from 'react-chartjs-2';
import { ArcElement } from 'chart.js';
import './raktkoshDashboard.css';

Chart.register(ArcElement);
const { Option } = Select;
const { Panel } = Collapse;
function Discard() {
  const selectData = ["Sample collected", "Printed", "All"];
  const accordionKeys = ['1', '2', '3', '4', '5'];
  const barChartData = {
    labels: ['AB- ve', 'AB+ ve', 'A- ve', 'A+ ve', 'B- ve', 'B+ ve', 'Oh- ve', 'Oh+ ve', 'O- ve', 'O+ ve'],
    datasets: [
      {
        label: 'Blood Availability Today',
        data: [2319, 4786, 4324, 1342, 5253, 9734, 8375, 2585, 9963, 2585],
        backgroundColor: '#50C0FF',
        borderWidth: 0,

      },
    ],
  };

  const numLabels = barChartData.labels.length;
  const maxChartHeight = 50 + numLabels * 30; // Adjust 50 and 30 as needed for padding and label height
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: {
        display: false, // Hide x-axis
        position: 'none',
      },
      y: {
        ticks: {
          beginAtZero: true, // Y axis starts at 0
          stepSize: 50, // Adjust the step size as needed
          autoSkip: false
        },
        display: true,
        position: 'left',
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
    maxHeight: maxChartHeight, // Set maximum height for chart before scrolling is enabled
    datasets: {
      bar: {
        barPercentage: 0.7, // Adjust the thickness of the bars
        categoryPercentage: 0.6, // Adjust the spacing between the bars
      },
    },
  };

  const barChartDataH = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August','September','October','November','December'],
    datasets: [
      {
        label: 'Blood Availability Today',
        data: [2319, 4786, 4324, 1342, 5253, 9734, 8375, 2585, 9963, 2585,1123,9987],
        backgroundColor: '#a8b7ca',
        borderWidth: 0,
      },
    ],
  }
  const optionsH = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        autoSkip: false
      }
    },
    datasets: {
      bar: {
        barPercentage: 0.7, // Adjust the thickness of the bars
        categoryPercentage: 0.6, // Adjust the spacing between the bars
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
  };
  return (
    <div>
      <div>
        <div><p className='stats mb-2'>Discard Section</p></div>
        <div className='d-flex gap-3 mb-4 minwP'>
          <div className='minwidth'>
            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
              <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Discard due to Expiry<DownloadOutlined onClick={(e) => e.stopPropagation()} /></span>} key="2">

                <div className='chartScrollBody'>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartData} options={options} style={{ width: '50%', height: '100%' }} />
                  </div>
                </div>
                <div >
                  <p className='mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn'>
                    <span>Count <ArrowUpOutlined /><ArrowDownOutlined /></span>
                    <span>State <ArrowUpOutlined /><ArrowDownOutlined /></span>
                  </p>
                </div>

              </Panel>
            </Collapse>
          </div>
          <div className='minwidth'>
            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
              <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Discard Due to Reactive <DownloadOutlined onClick={(e) => e.stopPropagation()} /></span>} key="2">

                <div className='chartScrollBody'>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartData} options={options} style={{ width: '50%', height: '100%' }} />
                  </div>
                </div>
                <div >
                  <p className='mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn'>
                    <span>Count <ArrowUpOutlined /><ArrowDownOutlined /></span>
                    <span>State <ArrowUpOutlined /><ArrowDownOutlined /></span>
                  </p>
                </div>

              </Panel>
            </Collapse>
          </div>
          <div className='minwidth'>
            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
              <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Higher Discards <DownloadOutlined onClick={(e) => e.stopPropagation()} /></span>} key="2">

                <div className='chartScrollBody'>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartData} options={options} style={{ width: '50%', height: '100%' }} />
                  </div>
                </div>
                <div >
                  <p className='mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn'>
                    <span>Count <ArrowUpOutlined /><ArrowDownOutlined /></span>
                    <span>State <ArrowUpOutlined /><ArrowDownOutlined /></span>
                  </p>
                </div>

              </Panel>
            </Collapse>
          </div>
          <div className='minwidth'>
            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
              <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Low Discards<DownloadOutlined onClick={(e) => e.stopPropagation()} /></span>} key="2">

                <div className='chartScrollBody'>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartData} options={options} style={{ width: '50%', height: '100%' }} />
                  </div>
                </div>
                <div >
                  <p className='mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn'>
                    <span>Count <ArrowUpOutlined /><ArrowDownOutlined /></span>
                    <span>State <ArrowUpOutlined /><ArrowDownOutlined /></span>
                  </p>
                </div>

              </Panel>
            </Collapse>
          </div>

        </div>
      </div>

      <div>
        <div className='row'>
          <div className='col-12'>

            <Collapse expandIconPosition="right" expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />} defaultActiveKey={accordionKeys} className='accodianHeader' >
              <Panel header={<span className='d-flex justify-content-between align-items-center stastHeaderTitlte'> Discard Trends <div> <Select
                style={{ width: 214 }}
                placeholder="select status"
                defaultValue={["Select Year"]}
                onClick={(e) => e.stopPropagation()}
              >
                {selectData.map((selectDatas, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={selectDatas}
                    ></Select.Option>
                  );
                })}
              </Select> <DownloadOutlined onClick={(e) => e.stopPropagation()} /></div></span>} key="2">

                <div className='chartScrollBodyNew'>
                  <div style={{ height: "280px" }}>
                    <Bar data={barChartDataH} options={optionsH} style={{ width: '100%', height: '100%' }} />
                  </div>
                </div>


              </Panel>
            </Collapse>
          </div>

        </div>
      </div>

    </div>
  )
}

export default Discard
